export const Heart = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			width="28"
			height="27"
			viewBox="0 0 28 27"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.9871 26.1694C14.4399 26.1694 15.1057 25.7832 15.7183 25.3837C23.0425 20.603 27.8499 14.9034 27.8499 9.19052C27.8499 3.95703 24.2144 0.441406 19.8465 0.441406C17.1299 0.441406 15.159 1.93288 13.9871 4.11683C12.8286 1.9462 10.8577 0.441406 8.14107 0.441406C3.77317 0.441406 0.137695 3.95703 0.137695 9.19052C0.137695 14.9034 4.94505 20.603 12.2693 25.3837C12.8818 25.7832 13.5477 26.1694 13.9871 26.1694Z"
				fill="white"
			/>
		</svg>
	);
};
